import React from 'react';
import Propagator from '../../Propagator';
import { Mutation } from 'react-apollo';
import gql from 'graphql-tag';

const CREATE_SESSION_MUTATION = gql`
	mutation($name: String!, $owners: [ID]) {
		createSession(name: $name, owners: $owners) {
			id
			name
			date
			owners {
				id
			}
		}
	}
`;

export default ({ children }) => (
	<Mutation mutation={CREATE_SESSION_MUTATION} refetchQueries={['adminQuery']}>
		{createUser => Propagator(children, createUser)}
	</Mutation>
);
